import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { AccordionPanelPadding } from '../accordion.types';

@Component({
  selector: 'wfm-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent {
  id: any;

  @Input() caretsOnRight = false;

  @Input() label: string;

  @Input() labelTemplate: TemplateRef<any>;

  @Input() secondaryHeadingLabel: string;

  @Input() icon: string;

  @Input() additionalText: string;

  @Input() selected: boolean;

  @Output() selectedChange = new EventEmitter<boolean>();

  @Input() skinny: boolean;

  @Input() filled = false;

  @Input() panelPadding = AccordionPanelPadding.all;

  toggle() {
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
  }

  close() {
    this.selected = false;
    this.selectedChange.emit(this.selected);
  }
}
